import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=60fe37c2&scoped=true&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=60fe37c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe37c2",
  null
  
)

export default component.exports